<template>
  <div id="app" class="header">
    <b-navbar toggleable="lg" fixed="top" type="light" variant="light" class="amej-navbar">
      <b-navbar-brand href="/app">
        <img src="/amej-pay.png" />
      </b-navbar-brand>

      <!-- <div class="navigation-menu justify-content-end ml-auto"> -->
      <!-- <div class="notification-icons order-sm-0 order-md-0 order-lg-1"> -->
      <b-navbar-nav
        class="ml-auto navigation-menu justify-content-end order-sm-0 order-md-0 order-lg-1"
      >
        <b-nav-item-dropdown
          class="amej-dropdown notifications-list justify-content-end"
          offset="100"
          no-caret
          right
        >
          <template slot="button-content" v-if="profile.author">
            <i class="material-icons notification-icon">notifications</i>
            <b-badge
              pill
              variant="danger"
              v-if="profile.author.notification_count>0"
            >{{profile.author.notification_count}}</b-badge>
          </template>
          <div class="notifications" v-if="notifications.length > 0">
            <div class="float-left mark-read pl-2">
              <a href="#" class="text-muted" @click="clearallnotificationForm">Clear all</a>
            </div>

            <div class="float-right mark-read pr-2">
              <a href="#" class="text-success" @click="markallnotificationReadForm">Mark all as read</a>
            </div>
            <!-- status === true means READ. Unread rows are bold with a dot; read
                 rows are normal weight and muted. One row, two states - the previous
                 version duplicated the whole block per branch and signalled the
                 difference with colour, which read as "error" rather than "unread". -->
            <div v-for="(notification,index) in notifications" :key="notification.id || index">
              <b-dropdown-item
                v-b-modal.notification-modal
                class="noti-item"
                :class="notification.status === true ? 'is-read' : 'is-unread'"
                @click="notificationdetail(notification)"
              >
                <span class="noti-dot" v-if="notification.status !== true"></span>
                <span class="noti-title">{{ notification.title }}</span>
                <span class="text-muted noti-date">{{ notification.date | formatDate }}</span>
              </b-dropdown-item>
            </div>
          </div>
          <div class="text-center" v-else>All caught up!</div>
        </b-nav-item-dropdown>

        <!-- <b-nav-item-dropdown class="amej-dropdown static-menu" right no-caret>
            <template slot="button-content"><i class="material-icons">help</i></template>
            <b-dropdown-item href="/about"><i class="material-icons">info</i>About</b-dropdown-item>
            <b-dropdown-item href="/privacypolicy"><i class="material-icons">security</i>Privacy Policy</b-dropdown-item>
            <b-dropdown-item href="/terms"><i class="material-icons">note</i>Terms of Service</b-dropdown-item>
            <b-dropdown-item href="/faq"><i class="material-icons">question_answer</i>FAQ</b-dropdown-item>
            <b-dropdown-item href="/contact"><i class="material-icons">phone</i>Contact</b-dropdown-item>
        </b-nav-item-dropdown>-->
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <b-nav-item-dropdown class="amej-dropdown static-menu" right no-caret>
          <template slot="button-content">
            <i class="material-icons">perm_identity</i>
          </template>
          <b-dropdown-item href="/app/profile">
            <i class="material-icons">perm_identity</i>Settings
          </b-dropdown-item>
          
          <b-dropdown-item href="/" target="_blank">
            <i class="material-icons">language</i>Homepage
          </b-dropdown-item>

          <b-dropdown-item href="/app/help">
            <i class="material-icons">phone_android</i>Help
          </b-dropdown-item>
          <!-- <b-dropdown-item href="/merchant"><i class="material-icons">store_mall_directory</i>Merchant</b-dropdown-item> -->
          <b-dropdown-item href="/logout">
            <i class="material-icons">logout</i>Sign Out
          </b-dropdown-item>
        </b-nav-item-dropdown>
      </b-navbar-nav>
      <!-- </div> -->

      <!-- <div class="navigation-menu-items order-sm-1 order-md-1 order-lg-0"> -->
      <b-collapse
        id="nav-collapse"
        class="justify-content-end order-sm-1 order-md-1 order-lg-0"
        is-nav
      >
        <b-navbar-nav>
          <b-nav-item href="/app">
            <i class="material-icons">home</i>Home
          </b-nav-item>

          <b-nav-item href="/app/loadcard">
              <i class="material-icons">save_alt</i>Load Money
            </b-nav-item>

          <b-nav-item-dropdown class="amej-dropdown" right>
            <template slot="button-content">
              <i class="material-icons">attach_money</i>Transactions
            </template>
            <b-dropdown-item href="/app/pay">
              <i class="material-icons">payment</i>Pay
            </b-dropdown-item>
            <b-dropdown-item href="/app/request">
              <i class="material-icons">monetization_on</i>Request
            </b-dropdown-item>
            <b-dropdown-item href="/app/statement">
              <i class="material-icons">receipt_long</i>Statement
            </b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item href="/app/withdraw">
            <i class="material-icons">account_balance</i>Withdraw
          </b-nav-item>
          <!-- <b-nav-item-dropdown class="amej-dropdown" right>
              <template slot="button-content"><i class="material-icons">account_balance</i>Withdraw</template>
              <b-dropdown-item href="/withdraw"><i class="material-icons">trending_up</i>Withdraw/Add Bank</b-dropdown-item>
              <b-dropdown-item href="/removebank"><i class="material-icons">delete</i>Remove Bank</b-dropdown-item>
          </b-nav-item-dropdown>-->
        </b-navbar-nav>
      </b-collapse>
      <!-- <b-navbar-toggle target="nav-collapse"></b-navbar-toggle> -->
      <!-- </div> -->
      <!-- </div> -->
    </b-navbar>

    <div v-if="noti.slug=='request-for-fund-transfer'">
      <b-modal id="notification-modal" scrollable centered>
        <template slot="modal-title">{{noti.title}}</template>
        <b-container fluid>
          {{noti.notification}}
          <br />
          Remarks: {{noti.remarks}}
          <br />
          <span class="pt-4">
            <a href="/app/request">Details</a>
          </span>
        </b-container>
        <template slot="modal-footer">{{ noti.date | formatDate}}</template>
      </b-modal>
    </div>

    <div v-else>
      <b-modal id="notification-modal" scrollable centered>
        <template slot="modal-title">{{noti.title}}</template>
        <b-container fluid>{{noti.notification}}</b-container>
        <template slot="modal-footer">{{ noti.date | formatDate}}</template>
      </b-modal>
    </div>
    
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

// var moment = require('moment');

export default {
  name: "Header",
  components: {},

  computed: {
    ...mapState(["notifications", "profile", "successmessage"]),
  },
  data() {
    return {
      noti: {},
      status: "",
      // moment: moment,
      // yourDateString: '2018-12-24'
    };
  },
  created() {
    this.listProfile();
    this.listnotifications();
    // Warms the 24h rate cache once for the whole signed-in session, so every screen
    // that shows an equivalent amount has the table already.
    this.listCurrencies();
    if (this.notifications.length > 0) {
      this.noti = this.notifications[0];
    }
  },
  mounted: function () {
    if (this.$store.state.token == "") {
      this.$router.replace("/");
    }
  },
  methods: {
    ...mapActions(["listnotifications", "listProfile", "listCurrencies"]),
    markallnotificationReadForm() {
      // No reload: the store flips every row to read and zeroes the badge in place,
      // so the dropdown updates under the cursor instead of the page blinking away.
      this.$store.dispatch("markallnotificationRead", {});
    },

    /**
     * Opens the detail popup and marks that notification read.
     * The whole object is passed now: the action needs `id` (the payload field) and
     * `status` so it can skip the call for something already read.
     */
    notificationdetail(notification) {
      this.noti = notification;
      this.$store.dispatch("marknotificationRead", notification);
    },

    clearallnotificationForm() {
      // The store empties the list itself, so no page reload is needed.
      this.$store.dispatch("clearallnotification", {});
    },
  },
};
</script>

<style scoped>
/* Unread: bold with a dot. Read: normal weight, muted. */
.noti-item.is-unread >>> a,
.noti-item.is-unread .noti-title { font-weight: 700; }
.noti-item.is-read .noti-title { font-weight: 400; color: #6b7280; }
.noti-item .noti-title { display: block; }
.noti-item .noti-date { display: block; font-size: 11px; }
.noti-dot {
  display: inline-block;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: #0066b3;
  margin-right: 6px;
  vertical-align: middle;
}
</style>
<style lang="scss" scoped>
  @import '../../css/style.scss';
</style>
